<section class="main-wrapper">
    <div class="menu-wrap">
      <div class="logo-wrap">
        <div class="logo">
          <img src="../../../../assets/images/Pilotbird_Logo_Light.png">

        </div>
        <a class="menu-btn">
          <span class="icon-bar top"></span>
          <span class="icon-bar center"></span>
          <span class="icon-bar bottom"></span>
        </a>
      </div>
      <div class="menu-box menu-icon-box" [class.suppress-menu-active]="isVeriskUser && !isAuthenticatedForMenu">
        <ul *ngFor="let module of Modules">
          <li class="clients"
              (click)="onMenuRowClick($event, module)"
              *ngIf="module.stDisplayName != 'Profile'">
                <a routerLink="{{ module.stRouterLink }}" href="#" routerLinkActive="active">
                  <ng-container *ngIf="module.stIcon.includes('.svg'); else iconShow">
                    <img [src]="iconFolderPath + module.stIcon" class="imageIcon">
                  </ng-container>
                  <ng-template #iconShow>
                    <i [class]="module.stIcon" size="lg" class="imageIcon"></i>
                  </ng-template>
                  {{ module.stDisplayName }}
                </a>
          </li>
          <!-- <li class="clients" *ngIf="module.stDisplayName != 'Profile'">
            <a routerLink="{{ module.stRouterLink }}" href="#" routerLinkActive="active">
              <fa-icon [icon]="['fas',module.stIcon]" size="lg" style="margin-right: 10px;"></fa-icon>
              {{ module.stDisplayName}}
            </a>
          </li>
          <li class="clients">
            <a routerLink="/payment-profile" href="#" routerLinkActive="active">
            <i class="fa fa-folder"></i>
            Payment Profile
          </a>
          </li>
          <li class="clients">
            <a routerLink="/code-verification" href="#" routerLinkActive="active">
            <i class="fa fa-folder"></i>
            Code Verification
          </a>
          </li>-->
        </ul>
      </div>
    </div>
    <div class="content-wrap">

      <div class="top-wrapper set-align">
        <a href="javascript:void(0)" class="menu-btn">
          <span class="icon-bar top"></span>
          <span class="icon-bar center"></span>
          <span class="icon-bar bottom"></span>
        </a>

        <div class="top-left-test">
          <h6 *ngIf="!isSuperAdminUser">{{clientName}}</h6>
        </div>

        <div class="top-center-btn" [ngClass]="{ 'ml-35': (!isSuperAdminUser && (clientName == '' || !clientName)) }">
          <div *ngIf="isSuperAdminUser == true  else NodataElseBlock" >
            <a class="btn-logged-in mr-left" href="javascript:void(0);" (click)="loginWithSuperAdmin()" data-testid="layout-logout-button"
              *ngIf="flgIsLoggedInWithEnabled">Logged in as '{{superAdminUserName}}'</a>
          </div>
        </div>
        <ng-template #NodataElseBlock>
          <a class="btn-logged-in" href="javascript:void(0);" (click)="loginWithSuperAdmin()" data-testid="layout-logout-button"
            *ngIf="flgIsLoggedInWithEnabled">Logged in as '{{superAdminUserName}}'</a>
        </ng-template>
        <!-- <div class="breadcrumbs">
                  <ul>
                      <li>Home <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                      <li><a href="#">Username <i class="fa fa-angle-right" aria-hidden="true"></i></a></li>
                  </ul>
              </div> -->
        <div class="user-link">
          <a  class="user-box text-capitalize">
            <div *ngIf="isLogIn" class="title">
              <h4 id="clickable" class="profile-name">{{name}}</h4><br>
            </div>
            <!-- <div class="img">
              <img [src]="profileImage">
            </div> -->
          </a>
          <div id="myDropdown" class="dropdown-content">
            <!-- <a href="/profile-setting">profile</a> -->
            <a *ngIf="!isVeriskUser" routerLink ="/profile-setting" href="#" routerLinkActive="active"><i></i>Profile</a>
            <a role="button" class="FontColor" (click)="logout(false)" data-testid="layout-logout-button">Logout</a>
          </div>

          <!-- Notification started -->
          <div class="notification-box" [ngClass]="[unreadNotifications.length>0 ? 'notification-box-count' : '']">
            <div class="notification" #targetElement>
              <span *ngIf="unreadNotifications.length > 9" class="more-notification-count">9+</span>
              <span *ngIf="unreadNotifications.length && unreadNotifications.length < 9" [ngClass]="unreadNotifications.length == 1 ? 'single-notification-count' : 'notification-counts'">{{unreadNotifications.length}}</span>

              <svg xmlns="http://www.w3.org/2000/svg" width="14px" height="17px" class="notification-icon-img" viewBox="0 0 20 10" fill="#1B1931" stroke="#535363" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 2 L22 21 L2 21 Z"></path>
              </svg>
              <svg viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg" *ngIf="unreadNotifications?.length==0" (click)="markAllAsReadNotifications()" class="bell-icon">
                <path d="M9 20C9.6193 20.0008 10.2235 19.8086 10.7285 19.4502C11.2335 19.0917 11.6143 18.5849 11.818 18H6.182C6.38566 18.5849 6.76648 19.0917 7.27151 19.4502C7.77654 19.8086 8.3807 20.0008 9 20ZM16 12.586V8C16 4.783 13.815 2.073 10.855 1.258C10.562 0.52 9.846 0 9 0C8.154 0 7.438 0.52 7.145 1.258C4.185 2.074 2 4.783 2 8V12.586L0.293001 14.293C0.199958 14.3857 0.126171 14.4959 0.0758854 14.6172C0.0256001 14.7386 -0.000189449 14.8687 1.04767e-06 15V16C1.04767e-06 16.2652 0.105358 16.5196 0.292894 16.7071C0.480431 16.8946 0.734785 17 1 17H17C17.2652 17 17.5196 16.8946 17.7071 16.7071C17.8946 16.5196 18 16.2652 18 16V15C18.0002 14.8687 17.9744 14.7386 17.9241 14.6172C17.8738 14.4959 17.8 14.3857 17.707 14.293L16 12.586Z" fill="white"/>
                </svg>

              <svg viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg" *ngIf="unreadNotifications.length>0" (click)="markAllAsReadNotifications()" class="bell-icon">
                <path d="M4.66612 1.71L3.26777 0.289997C0 3.563 0 5.935 0 8.99997H0.991739L1.98347 8.93697C1.98347 6.009 1.98347 4.396 4.66612 1.71ZM18.5494 0.289997L17.1531 1.71C19.8347 4.396 19.8347 6.009 19.8347 8.99997L21.8182 8.93697C21.8182 5.935 21.8182 3.563 18.5494 0.289997ZM10.9091 20C11.5233 20.0008 12.1224 19.8086 12.6233 19.4502C13.1241 19.0917 13.5018 18.5849 13.7038 18H8.11439C8.31633 18.5849 8.69403 19.0917 9.19491 19.4502C9.69571 19.8086 10.2949 20.0008 10.9091 20ZM17.8513 12.586V7.99999C17.8513 4.783 15.6843 2.073 12.7488 1.258C12.4582 0.519999 11.7481 0 10.9091 0C10.0701 0 9.36003 0.519999 9.06943 1.258C6.13289 2.073 3.96694 4.783 3.96694 7.99999V12.586L2.27405 14.293C2.18178 14.3857 2.10859 14.4959 2.05873 14.6172C2.00886 14.7386 1.98328 14.8686 1.98347 15V16C1.98347 16.2652 2.08795 16.5195 2.27394 16.7071C2.45993 16.8946 2.71218 17 2.9752 17H18.843C19.106 17 19.3582 16.8946 19.5442 16.7071C19.7302 16.5195 19.8347 16.2652 19.8347 16V15C19.8349 14.8686 19.8093 14.7386 19.7594 14.6172C19.7096 14.4959 19.6364 14.3857 19.5442 14.293L17.8513 12.586Z" fill="white"/>
                </svg>

            </div>
            <div class="notification-wrap content-scroll" [ngClass]="[name && name.length > 10 ? 'notification-wrap-large-name notification-right-spacing' : name && name.length <= 10 && name.length > 7 ? 'notification-wrap-medium-name notification-right-spacing' : 'notification-wrap-small-name notification-right-spacing']">
              <ul>
                <ng-container *ngIf="notifications.length>0">
                <li [ngClass]="[notification.flgIsUnread == true ? 'bg-box' : '', notification.inType == 2 ? 'true-box' : '']" *ngFor="let notification of notifications">
                  <a>
                    <h6>{{notification.stTitle}}</h6>
                    <p class="break-word">{{notification.stMessage}}</p>
                    <!-- This below 'relativetime' pipe used for change time format like seconds, minutes, hours, days ago  -->
                    <span>{{notification.dtCreatedOn | relativetime}}</span>
                  </a>
                </li>
              </ng-container>
              <ng-container *ngIf="notifications.length==0">
                <li>
                  <p class="no-notification">No notification available</p>
                </li>
              </ng-container>
              </ul>
            </div>
          </div>
          <!-- Notification end -->
          <div *ngIf="userteams && userteams.length > 0">
            <!-- Show the <h6> tag if there's exactly one team -->
             <h6 *ngIf="userteams.length === 1" class="align-content-right">{{ getTeamDisplayName(userteams[0].stName) }}</h6>
          </div>

          <div>
            <!-- Show the dropdown if there are more than one team -->
             <form *ngIf="userteams.length > 1" [formGroup]="form">
              <ng-container>
             <mat-select panelClass="layout-dropdown-container" data-testid="layout-team-input" formControlName="team" class="border-input select select-reviewer val-css select-team layout-team">
               <mat-option value="" disabled selected style="color: gray !important;">Select Team</mat-option>
               <mat-option *ngFor="let t of userteams" [value]="t.uiTeamId">{{ getTeamDisplayName(t.stName) }}</mat-option>
             </mat-select>
            </ng-container>
           </form> 
         </div>
        </div>
       
      </div>
     
      <router-outlet></router-outlet>
    </div>
  </section>